import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedTariffsDocument,
  RemoveTariffMutation,
  RemoveTariffMutationVariables,
  RemoveTariffDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { resetPaginationField } from "@/store/paginationStore";

/**
 * Custom hook for removing a tariff and handling the necessary cache updates.
 * @returns {Object} - Contains the removeTariffMutation function, loading state, and error state.
 */
export default function useRemoveTariffMutationHook(): {
  removeTariffMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeTariffMutation, { loading, error }] = useMutation<RemoveTariffMutation, RemoveTariffMutationVariables>(
    RemoveTariffDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedTariffs");

        toast(CustomToastComponent, {
          toastId: "tariff-removed-success",
          data: {
            title: t("toasts.tariffremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedTariffsDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              activeFrom: null,
              province: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeTariffMutation,
    loading,
    error,
  };
}
